// extracted by mini-css-extract-plugin
module.exports = {"bnt":"ButtonNext_bnt__3BKVB","btnDisabled":"ButtonNext_btnDisabled__1u9hn","beforeImg":"ButtonNext_beforeImg__3hTuE"};